import classnames from 'classnames/bind'
import { useTranslate } from 'react-polyglot'
import { GlobalThemeColors } from '~/@types/colors'
import { GlobalGridPreset } from '~/@types/grid-preset'
import { GlobalTextPreset } from '~/@types/text-preset'
import { GlobalTextStyling } from '~/@types/text-styling'

import { ProductCardProps } from '~/components/Slices/ProductCard'
import ResultItem from '~/components/Slices/Search/ResultItem'
import InlineCta from '~/components/UI/InlineCta'

import { useStyle } from '~/providers/StyleProvider'

import useTrackingProductImpression from '~/hooks/useTrackingProductImpresion'
import useTranslatedSmartCount from '~/hooks/useTranslatedSmartCount'

import { SEARCH } from '~/data/dictionary'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export interface ResultsGridProps {
  className?: string
  title?: string
  cards?: ProductCardProps[]
  onLoadMore?(): void
  canLoadMore?: boolean
  count: number
}

function ResultsGrid({
  className,
  count,
  title,
  cards,
  onLoadMore,
  canLoadMore,
}: ResultsGridProps) {
  const t = useTranslate()
  const gridStyle = useStyle({ grid: GlobalGridPreset.BASE_GRID })
  const titleStyle = useStyle({
    textPreset: GlobalTextPreset.Text12Haffer,
    color: GlobalThemeColors.MineShaft,
    textStyling: GlobalTextStyling.UpperCase,
  })
  const ctaStyle = useStyle({
    textPreset: GlobalTextPreset.Cta12Haffer,
    color: GlobalThemeColors.Black,
    textStyling: GlobalTextStyling.UpperCase,
  })

  const countAvailabilityStyle = useStyle({
    textPreset: GlobalTextPreset.Text11_12Haffer,
    color: GlobalThemeColors.DoveGray,
    textStyling: GlobalTextStyling.UpperCase,
  })

  const COUNT_TRANSLATION = useTranslatedSmartCount(
    [SEARCH.COUNT_AVAILABILITY, SEARCH.COUNT_AVAILABILITIES],
    count,
  )

  const { ref } = useTrackingProductImpression(cards)

  return (
    <div ref={ref} className={cx(css.ResultsGrid, gridStyle, className)}>
      <div className={css.texts}>
        {title && <p className={titleStyle}>{title}</p>}

        <div className={cx(css.countAvailability, countAvailabilityStyle)}>
          {COUNT_TRANSLATION}
        </div>
      </div>
      <div className={css.content}>
        {cards?.map((card, index) => (
          <ResultItem
            className={css.item}
            key={`result_item_${index}`}
            index={index}
            {...card}
          />
        ))}
      </div>
      {canLoadMore && (
        <div className={css.loadMore}>
          <InlineCta
            className={cx(css.cta, ctaStyle)}
            onClick={() => onLoadMore?.()}>
            {t(SEARCH.LOAD_MORE)}
          </InlineCta>
        </div>
      )}
    </div>
  )
}

ResultsGrid.defaultProps = {}

export default ResultsGrid
